var _g, _path, _g2, _path2, _g3, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 450,
    viewBox: "0 0 1440 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 192L80 208C160 224 320 256 480 224C640 192 800 96 960 53.3C1120 11 1280 21 1360 26.7L1440 32V320H1360C1280 320 1120 320 960 320C800 320 640 320 480 320C320 320 160 320 80 320H0V192Z",
    fill: "#8C7DB6"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.2,
    y: 21.2181,
    width: 1440.4,
    height: 298.982
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.1px)",
      clipPath: "url(#bgblur_1_1_9_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 0.2,
    d: "M0 192L80 208C160 224 320 256 480 224C640 192 800 96 960 53.3C1120 11 1280 21 1360 26.7L1440 32V320H1360C1280 320 1120 320 960 320C800 320 640 320 480 320C320 320 160 320 80 320H0V192Z",
    fill: "url(#paint0_linear_1_9)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 160L48 176C96 192 192 224 288 234.7C384 245 480 235 576 234.7C672 235 768 245 864 213.3C960 181 1056 107 1152 85.3C1248 64 1344 96 1392 112L1440 128V320H1392C1344 320 1248 320 1152 320C1056 320 960 320 864 320C768 320 672 320 576 320C480 320 384 320 288 320C192 320 96 320 48 320H0V160Z",
    fill: "#FFB84E",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: 74.2145,
    width: 1448,
    height: 249.786
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_2_1_9_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M0 160L48 176C96 192 192 224 288 234.7C384 245 480 235 576 234.7C672 235 768 245 864 213.3C960 181 1056 107 1152 85.3C1248 64 1344 96 1392 112L1440 128V320H1392C1344 320 1248 320 1152 320C1056 320 960 320 864 320C768 320 672 320 576 320C480 320 384 320 288 320C192 320 96 320 48 320H0V160Z",
    fill: "url(#paint1_linear_1_9)",
    fillOpacity: 0.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 124.991 C30 117 70 108 120 96 C200 76 300 50 400 52 C500 54 580 78 640 110 C700 142 760 190 840 210 C920 230 1000 220 1080 205 C1160 190 1240 170 1320 180 C1360 185 1400 200 1440 215 L1440 450 H0 V124.991Z",
    fill: "#5C4691"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: 40.1716,
    width: 1448,
    height: 413.829
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_3_1_9_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M0 124.991 C30 117 70 108 120 96 C200 76 300 50 400 52 C500 54 580 78 640 110 C700 142 760 190 840 210 C920 230 1000 220 1080 205 C1160 190 1240 170 1320 180 C1360 185 1400 200 1440 215 L1440 450 H0 V124.991Z",
    fill: "url(#paint2_linear_1_9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_9",
    x: -4,
    y: 17.4181,
    width: 1448,
    height: 306.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1_9_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.2 -21.2181)",
    d: "M0 192L80 208C160 224 320 256 480 224C640 192 800 96 960 53.3C1120 11 1280 21 1360 26.7L1440 32V320H1360C1280 320 1120 320 960 320C800 320 640 320 480 320C320 320 160 320 80 320H0V192Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_9",
    x: -20,
    y: 58.2145,
    width: 1480,
    height: 281.786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1_9_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(4 -74.2145)",
    d: "M0 160L48 176C96 192 192 224 288 234.7C384 245 480 235 576 234.7C672 235 768 245 864 213.3C960 181 1056 107 1152 85.3C1248 64 1344 96 1392 112L1440 128V320H1392C1344 320 1248 320 1152 320C1056 320 960 320 864 320C768 320 672 320 576 320C480 320 384 320 288 320C192 320 96 320 48 320H0V160Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_9",
    x: -2.4,
    y: 44.3683,
    width: 1444.8,
    height: 408.032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_1_9_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(4 -40.1716)",
    d: "M0 124.991L40 114.191C80 103.795 166.5 86 304.5 58C435 33 482 47.5 504.5 58C580.433 93.4356 640 168.393 720 205.738C800 243.084 880 232.991 960 216.538C1040 200.692 1120 178.486 1200 184.239C1280 189.589 1360 221.888 1400 238.037L1440 254.187V450H1400C1360 450 1280 450 1200 450C1120 450 1040 450 960 450C880 450 800 450 720 450C640 450 560 450 480 450C400 450 450 450 240 450C160 450 80 450 40 450H0V124.991Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9",
    x1: 0,
    y1: 29879.6,
    x2: 11871.7,
    y2: -27375.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8C7DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4691"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9",
    x1: 0,
    y1: 24256.8,
    x2: 7896.84,
    y2: -22774.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_9",
    x1: 0.034564,
    y1: 40743,
    x2: 21304.9,
    y2: -34635.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5C4691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2F61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 450,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBg);
export default __webpack_public_path__ + "static/media/auth_bg.779fc635e2fdf0cd80c44a22fd950423.svg";
export { ForwardRef as ReactComponent };